import axios from 'axios';
import config from 'config/config';
import { captureException } from '@sentry/react';
import { RampQuota } from '../interfaces';

const MIN_CRYPTO_AMOUNT = 1;

const BASE_URL = config.rampWidgetUrl?.includes('demo')
  ? 'https://api.demo.ramp.network/api'
  : 'https://api.ramp.network/api';

/**
 * Reference: https://docs.ramp.network/rest-api-v3-reference#on-ramp-purchase-quotation
 */
export const fetchQuota = ({
  fiatCurrency,
  tokenName,
  amount,
}: {
  fiatCurrency: string;
  tokenName: string;
  amount: number;
}): Promise<RampQuota | void> => {
  const queryParams = new URLSearchParams({
    hostApiKey: config.rampHostApiKey,
  });

  const data = {
    fiatCurrency: fiatCurrency,
    cryptoAssetSymbol: tokenName,
    cryptoAmount: Math.max(MIN_CRYPTO_AMOUNT, amount).toString(),
  };

  return axios
    .post<RampQuota>(`${BASE_URL}/host-api/v3/onramp/quote/all?${queryParams.toString()}`, data)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        captureException(error);
      }
    );
};
